import { render, staticRenderFns } from "./CommonWritePuResult.vue?vue&type=template&id=aa131e68&scoped=true"
import script from "./CommonWritePuResult.vue?vue&type=script&lang=js"
export * from "./CommonWritePuResult.vue?vue&type=script&lang=js"
import style0 from "./CommonWritePuResult.vue?vue&type=style&index=0&id=aa131e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa131e68",
  null
  
)

export default component.exports